import React, { ReactElement, useEffect, useState } from 'react';
import { Layout } from 'elmo-elements';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';

import {
  useGetQuestionQuery,
  useGetQuizQuery,
  useGetThemesQuery,
} from '@/modules/services';
import Header from '@/pages/Module/components/Header';
import QuizRoutes from '../routes';
import { QuestionParamType } from './routes';
import NoQuestion from '../components/NoQuestion';
import QuizSideBar from '../components/QuizSidebar';
import QuestionForm from '../components/Questions';

import '../Quiz.scss';

const QuizQuestionsComponent = (): ReactElement => {
  const handleError = useErrorHandler();
  const [isValidQuestionId, setIsValidQuestionId] = useState<boolean>(true);
  const history = useHistory();
  const { elearningId, questionId } = useParams<QuestionParamType>();

  if (!questionId) {
    history.push(
      generatePath(QuizRoutes.path, {
        elearningId,
      }),
    );
  }

  const quiz = useGetQuizQuery(elearningId);
  const questionData = useGetQuestionQuery({ questionId });
  const themes = useGetThemesQuery();

  useEffect(() => {
    if (questionData.isFetching || questionData.isLoading) return;

    setIsValidQuestionId(questionData.isSuccess && !!questionData.data);
  }, [questionId, questionData]);

  if (quiz.isError) {
    handleError(quiz.error);
  }

  if (themes.isError) {
    handleError(themes.error);
  }

  const showQuestionComponent = () =>
    isValidQuestionId ? <QuestionForm /> : <NoQuestion />;

  return (
    <>
      <Layout.Header>
        <Header />
      </Layout.Header>
      <div className="editor-layout__body">
        <QuizSideBar />
        <Layout.Content>
          <div className="center-content">
            {quiz.isLoading ? (
              <div className="loading" />
            ) : (
              showQuestionComponent()
            )}
          </div>
        </Layout.Content>
      </div>
    </>
  );
};

export default QuizQuestionsComponent;
